import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Tabs, Tab, Dropdown, DropdownButton, MenuItem } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Tabs
import StaffEditTab from './Elements/StaffEditTab';
import StaffLicensesTab from './Elements/StaffLicensesTab';
import StaffTasksTab from './Elements/StaffTasksTab';
import StaffAircraftModelsTab from './Elements/StaffAircraftModelsTab';
import StaffFleetsTab from './Elements/StaffFleetsTab';
import StaffDesignationsTab from './Elements/StaffDesignationsTab';
import StaffJobsTab from './Elements/StaffJobsTab';
import StaffLanguagesTab from './Elements/StaffLanguagesTab';
import StaffVacationsTab from './Elements/StaffVacationsTab';
import StaffRolesTab from './Elements/StaffRolesTab';
import StaffBasesTab from './Elements/StaffBasesTab';
import StaffContractualBasesTab from './Elements/StaffContractualBasesTab';
import StaffCostsTab from './Elements/StaffCostsTab';
import StaffGuaranteedHoursTab from './Elements/StaffGuaranteedHoursTab';
import StaffAircraftsTab from './Elements/StaffAircraftsTab';
import StaffGradesTab from './Elements/StaffGradesTab';
import StaffPostsTab from './Elements/StaffPostsTab';
import StaffStampsTab from './Elements/StaffStampsTab';
import StaffCertificationsTab from './Elements/StaffCertificationsTab';
import StaffNeededTrainingsTab from './Elements/StaffNeededTrainingsTab';
import StaffChecksTab from './Elements/StaffChecksTab';
import StaffReferencesTab from './Elements/StaffReferencesTab';
import StaffAbsencesTab from './Elements/StaffAbsencesTab';
//21
import StaffAttestationsTab from './Elements/StaffAttestationsTab';
import StaffRegimesTab from './Elements/StaffRegimesTab';
import StaffEducationsTab from './Elements/StaffEducationsTab';
import StaffOJTsTab from './Elements/StaffOJTsTab';
import getLocale from '../../i18n/getLocale';
//25


class SigmecStaffsEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      situation: 'Demitido',
      staff_id: this.props.match.params.id,
      staff_data: {},
      staff_roles: {},
      staff_tasks: {},
      staff_contractual_bases: {},
      staff_aircraft_models: {},
      regimes_select: {},
      uf_list: [],
      tasks_list: [],
      aircraft_models_list: [],
      aircraft_model_subtypes_list: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.changeSituation = this.changeSituation.bind(this);
    this.export = this.export.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  changeSituation(situation) {
    if (window.confirm(this.locale.ColaboradoresSigmec.EdicaoDeColaborador.trocarStatusDoColaborador)) {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      self.setState({overlay: {message: '', type: '', status: 'open'}});
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api_sigmec') + '/colaborador/trocar/status/' + self.props.match.params.id + '/' + situation, { method: 'PUT', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({
              staff_data: responseJson.data.main,
              situation: responseJson.data.main.situation,
            });
          }
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
        });
      });
    }
  }

  export(url) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigmec') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
        }
      });
    });
  }

  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api_sigmec') + '/portal/funcionario/sigmec';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/colaboradores');
        if (responseJson.status === 'success') {
          self.setState({
            staff_data: responseJson.data.main,
            situation: responseJson.data.main.situation,
            url_anac: responseJson.data.url_anac,
            url_anac_dob: responseJson.data.url_anac_dob,
            staff_roles: responseJson.data.staff_roles,
            staff_licenses: responseJson.data.staff_licenses,
            staff_tasks: responseJson.data.staff_tasks,
            staff_fleets: responseJson.data.staff_fleets,
            staff_aircraft_models: responseJson.data.staff_aircraft_models,
            staff_jobs: responseJson.data.staff_jobs,
            staff_grades: responseJson.data.staff_grades,
            staff_languages: responseJson.data.staff_languages,
            staff_vacations: responseJson.data.staff_vacations,
            staff_roles: responseJson.data.staff_roles,
            staff_bases: responseJson.data.staff_bases,
            staff_contractual_bases: responseJson.data.staff_contractual_bases,
            staff_aircrafts: responseJson.data.staff_aircrafts,
            staff_posts: responseJson.data.staff_posts,
            staff_stamps: responseJson.data.staff_stamps,
            staff_checks: responseJson.data.staff_checks,
            staff_references: responseJson.data.staff_references,
            staff_absences: responseJson.data.staff_absences,
            staff_revisions: responseJson.data.staff_revisions,
            staff_revisions_list: responseJson.data.staff_revisions_list,
            staff_designations_finalized: responseJson.data.staff_designations_finalized,
            staff_attestations: responseJson.data.staff_attestations,
            staff_regimes: responseJson.data.staff_regimes,
            staff_educations: responseJson.data.staff_educations,
            staff_needed_trainings: responseJson.data.staff_needed_trainings,
            staff_needed_trainings_new: responseJson.data.staff_needed_trainings_new,
            staff_necessities: responseJson.data.staff_necessities,
            staff_designations: responseJson.data.staff_designations,
            staff_designations_open: responseJson.data.staff_designations_open,
            staff_certifications: responseJson.data.staff_certifications,
            staff_costs: responseJson.data.staff_costs,
            staff_guaranteed_hours: responseJson.data.staff_guaranteed_hours,
            staff_ojts: responseJson.data.staff_ojts,
            absences_list: responseJson.data.absences_list,
            references_list: responseJson.data.references_list,
            posts_list: responseJson.data.posts_list,
            aircrafts_list: responseJson.data.aircrafts_list,
            bases_list: responseJson.data.bases_list,
            roles_list: responseJson.data.roles_list,
            tasks_list: responseJson.data.tasks_list,
            certifications_list: responseJson.data.certifications_list,
            aircraft_models_list: responseJson.data.aircraft_models_list,
            aircraft_model_subtypes_list: responseJson.data.aircraft_model_subtypes_list,
            uf_list: responseJson.data.uf_list,
            staff_list: responseJson.data.staff_list,
            regimes_select: responseJson.data.regimes_select,
            designations_list: responseJson.data.designations_list,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      });
    });
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.titulo} - {this.state.staff_data.name}</h3>
      {/* <div className="grid-buttons pull-right">
        <Dropdown id="export-data">
          <Dropdown.Toggle bsStyle={'primary'}>
            <i className="fa fa-fw fa-file-pdf-o"></i> Exportações
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <MenuItem header>ID</MenuItem>
            <MenuItem onSelect={this.export} eventKey={'/portal/exportar/identificacao/full/colaborador'}>Visualizar ID</MenuItem>
            <MenuItem divider />
            <MenuItem header>ID - Pasta</MenuItem>
            <MenuItem onSelect={this.export} eventKey={'/portal/exportar/identificacao/pasta/colaborador'}>Visualizar ID para pasta</MenuItem>
            <MenuItem divider />
            <MenuItem header>Currículo</MenuItem>
            <MenuItem onSelect={this.export} eventKey={'/portal/exportar/curriculo/colaborador'}>Visualizar currículo</MenuItem>
            <MenuItem divider />
            <MenuItem header>Link ANAC</MenuItem>
            <MenuItem href={this.state.url_anac} target="_blank">Consulta por cpf</MenuItem>
            <MenuItem href={this.state.url_anac_dob} target="_blank">Consulta por nascimento</MenuItem>
          </Dropdown.Menu>
        </Dropdown>
      </div> */}
      <div className="clearfix"></div>
      <hr/>
      <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id="controlled-tab-example">
        <Tab eventKey={1} title={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.tituloTab}>
          <StaffEditTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_data={this.state.staff_data} uf_list={this.state.uf_list} />
        </Tab>
        <Tab eventKey={2} title={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.tituloTab}>
          <StaffLicensesTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_licenses={this.state.staff_licenses} />
        </Tab>
        <Tab eventKey={3} title={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTarefasDesignadas.tituloTab}>
          <StaffTasksTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_tasks={this.state.staff_tasks} tasks_list={this.state.tasks_list} />
        </Tab>
        <Tab eventKey={4} title={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasDesignadas.tituloTab}>
          <StaffAircraftModelsTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_aircraft_models={this.state.staff_aircraft_models} aircraft_model_subtypes_list={this.state.aircraft_model_subtypes_list} aircraft_models_list={this.state.aircraft_models_list} />
        </Tab>
        <Tab eventKey={5} title={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasObrigatorias.tituloTab}>
          <StaffFleetsTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_fleets={this.state.staff_fleets} aircraft_model_subtypes_list={this.state.aircraft_model_subtypes_list} aircraft_models_list={this.state.aircraft_models_list} />
        </Tab>
        <Tab eventKey={6} title={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tituloTab}>
          <StaffDesignationsTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_designations={this.state.staff_designations} staff_designations_open={this.state.staff_designations_open} designations_list={this.state.designations_list} staff_revisions={this.state.staff_revisions} staff_revisions_list={this.state.staff_revisions_list} staff_designations_finalized={this.state.staff_designations_finalized} loadData={this.loadData} />
        </Tab>
        <Tab eventKey={7} title={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabExperienciaProfissional.tituloTab}>
          <StaffJobsTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_jobs={this.state.staff_jobs} staff_list={this.state.staff_list} />
        </Tab>
        <Tab eventKey={8} title={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabProvasDeIdioma.tituloTab}>
          <StaffLanguagesTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_languages={this.state.staff_languages} />
        </Tab>
        <Tab eventKey={9} title={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFerias.tituloTab}>
          <StaffVacationsTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_vacations={this.state.staff_vacations} />
        </Tab>
        <Tab eventKey={10} title={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFuncoes.tituloTab}>
          <StaffRolesTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} roles_list={this.state.roles_list}  staff_roles={this.state.staff_roles} />
        </Tab>
        <Tab eventKey={11} title={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabBases.tituloTab}>
          <StaffBasesTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} bases_list={this.state.bases_list}  staff_bases={this.state.staff_bases} />
        </Tab>
        <Tab eventKey={13} title={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNiveisDeCargos.tituloTab}>
          <StaffGradesTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_grades={this.state.staff_grades} />
        </Tab>
        <Tab eventKey={14} title={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCargos.tituloTab}>
          <StaffPostsTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_posts={this.state.staff_posts} posts_list={this.state.posts_list} />
        </Tab>
        <Tab eventKey={15} title={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.tituloTab}>
          <StaffStampsTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_stamps={this.state.staff_stamps} roles_list={this.state.roles_list}  />
        </Tab>
        <Tab eventKey={16} title={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTreinamentos.tituloTab}>
          <StaffCertificationsTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_certifications={this.state.staff_certifications} certifications_list={this.state.certifications_list} />
        </Tab>
        <Tab eventKey={17} title={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tituloTab}>
          <StaffNeededTrainingsTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_needed_trainings_new={this.state.staff_needed_trainings_new} staff_needed_trainings={this.state.staff_needed_trainings} staff_necessities={this.state.staff_necessities} />
        </Tab>
        <Tab eventKey={19} title={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabColaboradorReferencia.tituloTab}>
          <StaffReferencesTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_references={this.state.staff_references} references_list={this.state.references_list} aircraft_models_list={this.state.aircraft_models_list} />
        </Tab>
        <Tab eventKey={20} title={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabAfastamentos.tituloTab}>
          <StaffAbsencesTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_absences={this.state.staff_absences} absences_list={this.state.absences_list} />
        </Tab>
        <Tab eventKey={23} title={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabRegimeDeTrabalho.tituloTab}>
          <StaffRegimesTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_regimes={this.state.staff_regimes} regimes_select={this.state.regimes_select} />
        </Tab>
        <Tab eventKey={24} title={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFormacaoAcademica.tituloTab}>
          <StaffEducationsTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_educations={this.state.staff_educations} />
        </Tab>
        {/* <Tab eventKey={25} title="OJT">
          <StaffOJTsTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_ojts={this.state.staff_ojts} />
        </Tab> */}
        <Tab eventKey={26} title={this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabBaseContratual.tituloTab}>
          <StaffContractualBasesTab handleAlert={this.handleAlert} staff_contractual_bases={this.state.staff_contractual_bases} staff_id={this.props.match.params.id} bases_list={this.state.bases_list} />
        </Tab>
        {/* <Tab eventKey={27} title="Centro de custo">
          <StaffCostsTab handleAlert={this.handleAlert} staff_costs={this.state.staff_costs} staff_id={this.props.match.params.id} />
        </Tab> */}
        {/* <Tab eventKey={28} title="Horas Garantidas">
          <StaffGuaranteedHoursTab handleAlert={this.handleAlert} staff_guaranteed_hours={this.state.staff_guaranteed_hours} staff_id={this.props.match.params.id} />
        </Tab> */}
      </Tabs>
    </div>
  </div>
</div>
    );
  }
}

export default SigmecStaffsEdit;



// WEBPACK FOOTER //
// ./src/Components/SigmecStaffs/SigmecStaffsEdit.js